export const COOKIE_SIGNIN_EMAIL = 'cookie_signin_email';
